// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"3603f31c","787":"349b0e60","850":"ce4745ff"}[chunkId] + ".chunk.js";
};